/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProviderQuestionnaireRead } from '../models/ProviderQuestionnaireRead';
import type { ProviderQuestionnaireWrite } from '../models/ProviderQuestionnaireWrite';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class QuestionnaireService {

    /**
     * Retrieve a ProviderQuestionnaire by provider ID
     * @returns ProviderQuestionnaireRead
     * @throws ApiError
     */
    public static questionnaireRetrieve({
        providerId,
    }: {
        providerId: string,
    }): CancelablePromise<ProviderQuestionnaireRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/questionnaire/{provider_id}/',
            path: {
                'provider_id': providerId,
            },
        });
    }

    /**
     * Update a ProviderQuestionnaire by provider ID
     * @returns ProviderQuestionnaireRead
     * @throws ApiError
     */
    public static questionnaireUpdate({
        providerId,
        requestBody,
    }: {
        providerId: string,
        requestBody: ProviderQuestionnaireWrite,
    }): CancelablePromise<ProviderQuestionnaireRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/questionnaire/{provider_id}/',
            path: {
                'provider_id': providerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static questionnairePdfRetrieve({
        providerId,
    }: {
        providerId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/questionnaire/{provider_id}/pdf',
            path: {
                'provider_id': providerId,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static questionnaireTextRetrieve({
        providerId,
    }: {
        providerId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/questionnaire/{provider_id}/text',
            path: {
                'provider_id': providerId,
            },
        });
    }

}
